import React, { useState } from "react";
import "./style.css";

import { CampoObrigatorio, COR_DEFAULT, handleValidaCampos } from "../../pages/PesquisaSatisfacao";
import { BiSolidLike, BiSolidDislike  } from "react-icons/bi";

const SimNao = ( {item, register, setValue, getValues} ) => {
    const campo = `id_${item.codperguntaSatisfacao}`;
    const campoComplemento = `id_complemento_${item.codperguntaSatisfacao}`;
    const lista = [
        {value: "S", text: "Sim"},
        {value: "N", text: "Não"},
    ];
    const [valor, setValor] = useState("");
    const [valorComplemento, setValorComplemento] = useState("");

    function handleItem(value) {
        setValue(campo, value);
        setValor(value);
        handleValidaCampos(getValues(), item);
    }

    function handleItemComplemento(value) {
        setValue(campoComplemento, value);
        setValorComplemento(value);
    }

    return (
        <div className="pesquisa-satisfacao-item-container" key={`_sim_nao_${item.codperguntaSatisfacao}`}>
            <CampoObrigatorio id={`div_${item.codperguntaSatisfacao}`} key={`_sim_nao_2_${item.codperguntaSatisfacao}`}/>

            <span className="pesquisa-satisfacao-item-texto" key={`_sim_nao_3_${item.codperguntaSatisfacao}`}>{item.texto}</span>
            
            <div className="sim-nao-content" key={`${campo}_${item.value}`}>
                {lista?.map(item => {
                    return (
                        <>
                            <div 
                                className="sim-nao-item-content" 
                                key={`_sim_nao_4_${item.codperguntaSatisfacao}`}
                                style={{
                                    backgroundColor: valor === item.value ? COR_DEFAULT : null,
                                    color: valor === item.value ? "#FFF" : "#000",
                                }} 
                                onClick={() => handleItem(item.value)}
                            >
                                {
                                    item?.value === "S"
                                    ? <BiSolidLike key={`_sim_nao_7_${item.codperguntaSatisfacao}`} size={16} color={valor === "S" ? "#FFF" : "#000"}/>
                                    : <BiSolidDislike size={16} key={`_sim_nao_8_${item.codperguntaSatisfacao}`} color={valor === "N" ? "#FFF" : "#000"}/>
                                }
                                <span className="sim-nao-item" key={`_sim_nao_5_${item.codperguntaSatisfacao}`}>
                                    {item.text}
                                </span>
                            </div>
                        </>                       
                    )
                })}
            </div>

            {
                item?.complemento &&
                <div className="sim-nao-item-complemento-content">
                    <span>{item?.textoComplemento}</span>
                    <input 
                        className="sim-nao-item-complemento-input"
                        onKeyUp={(e) => handleItemComplemento(e.target.value)} 
                    />

                    <input style={{display: "none"}} defaultValue={""} {...register(campoComplemento, { required: false })}></input>
                </div>
            }

            <input style={{display: "none"}} defaultValue={''} {...register(campo, { required: false })}></input>
        </div>
    )
}

export default SimNao;